import { IColumnWidths } from '../models/ColumnWidths';
import { Keys } from './Keys';

export interface IDropdownScope<TModel, TRow> extends ng.IScope {
  model: TModel;

  editMode: boolean;
  textValue: string;

  currentRow: {
    index: number;
    object: any;
  };

  select: (item: any) => void;
  cancel: () => void;
  clear: () => void;
  edit: () => void;
  handleKeyEvent: ($event: BaseJQueryEventObject) => void;
  mousedownOutside: ($event: BaseJQueryEventObject) => void;

  columnWidths?: IColumnWidths;
}

export class DropdownHelper {

  public static setupDropdownScope<TModel, TRow>(
    scope: IDropdownScope<TModel, TRow>,
    $timeout: ng.ITimeoutService,
    focusElement: JQuery,
    rowToModel: (TRow: any) => TModel
  ) {

    // State transitions (edit, cancel, select, etc.)

    scope.currentRow = {
      index: 0,
      object: null
    };

    function reset() {
      scope.editMode = false;
      scope.textValue = '';
      scope.currentRow.index = -1;
    }

    reset();

    scope.select = (item: TRow) => {
      try {
        scope.model = rowToModel(item);
      } catch(e) {
        return;
      }

      reset();
    };

    scope.cancel = () => {
      reset();
    };

    scope.clear = () => {
      scope.model = null;
      reset();
    };

    scope.edit = () => {
      scope.editMode = true;
      focus();
    };

    function focus() {
      $timeout(() => focusElement.focus());
    }

    // Close if the user clicks outside the dropdown
    scope.mousedownOutside = ($event: JQueryEventObject) => {
      if ($($event.target).closest(focusElement).length === 0) {
        scope.cancel();
      }
    };

    // Keyboard handling

    scope.handleKeyEvent = ($event: BaseJQueryEventObject) => {

      switch ($event.which) {

        case Keys.ArrowDown:
          scope.currentRow.index++;
          break;

        case Keys.ArrowUp:
          // Don't let the index go below 0 on arrow up
          scope.currentRow.index = Math.max(scope.currentRow.index - 1, 0);
          break;

        case Keys.Enter:
        case Keys.Tab:
          $event.preventDefault();
          scope.select(scope.currentRow.object);
          break;


        case Keys.Escape:
          $event.preventDefault();
          scope.cancel();
          break;
      }
    };
  }

}
